export default __webpack_public_path__ + "static/media/1069.74c42578.png";